import React from 'react';
import styled from 'styled-components';
import SvgSelector from '../helpers/SvgSelector';
import Map from '../svg/Map';
import Chart, { SChart } from '../svg/Chart';
import { questions } from '../Content';
import ColorKey from './reusableObjects/ColorKey';
import { breakpoints } from '../styles/utilities/settings';
import { AppContext } from '../App';
import Loading, { SLoading } from './Loading';

const Outlook = () => (
  <AppContext.Consumer>
    {value => (
      <SOutlook>
        <SideBySide>
          <div>
            <h2>30-day Pest Risk Outlook</h2>
            <ColorKey />
            <div className="app-container">
              <div className="chart">
                <h3>Overall USA</h3>
                {value.average ? (
                  <Chart percent={value.average} />
                ) : (
                  <Loading justSpinner />
                )}
              </div>
              <div className="map">
                <h3>By State</h3>
                <Map />
              </div>
            </div>
          </div>
          <div>
            <h2>Did you know?</h2>
            {questions.map(({ icon, copy }) => (
              <Question key={Math.random()}>
                <SvgSelector icon={icon} width={50} />
                <p>{copy}</p>
              </Question>
            ))}
          </div>
        </SideBySide>
      </SOutlook>
    )}
  </AppContext.Consumer>
);

export default Outlook;

const Question = styled.div`
  display: flex;
  align-items: flex-start;
  max-width: 450px;
  margin: 0 auto;

  + div {
    margin-top: 20px;
  }

  > * {
    &:first-child {
      width: 50px;
      padding-right: 20px;
      box-sizing: content-box;
    }

    &:last-child {
      width: calc(100% - 70px);
      text-align: left;
      font-size: 14px;
      line-height: 1.8 !important;
      margin-top: 0;
    }
  }
`;

export const SideBySide = styled.div`
  overflow: hidden;
  text-align: center;

  @media screen and (min-width: ${breakpoints.ipadPort}px) {
    display: flex;
    justify-content: space-between;
  }

  h2,
  h3 {
    font-weight: 100 !important;
  }

  h2 {
    margin-bottom: 30px !important;
    text-transform: uppercase;
  }

  > div {
    &:nth-child(1) {
      @media screen and (min-width: ${breakpoints.ipadLand}px) {
        width: calc(100% - ${breakpoints.pageWidth * 0.3}px);
        padding-right: 50px;
      }
      @media (max-width: ${breakpoints.ipadLand -
          1}px) and (min-width: ${breakpoints.ipadPort}px) {
        width: 60%;
        padding-right: 20px;
      }
    }

    &:nth-child(2) {
      @media screen and (min-width: ${breakpoints.ipadLand}px) {
        width: 30%;
        padding-left: 50px;
        max-width: ${breakpoints.pageWidth * 0.3}px;
      }
      @media (max-width: ${breakpoints.ipadLand -
          1}px) and (min-width: ${breakpoints.ipadPort}px) {
        width: 40%;
        padding-left: 20px;
      }
    }
  }
`;

const SOutlook = styled.div`
  ${SChart} {
    @media screen and (max-width: ${breakpoints.ipadLand - 1}px) {
      margin-bottom: 30px;
    }
  }

  .app-container {
    @media screen and (min-width: ${breakpoints.ipadLand}px) {
      display: flex;
      justify-content: space-between;
    }

    > div {
      max-width: 300px;
      margin: 0 auto;
      @media screen and (min-width: ${breakpoints.ipadLand}px) {
        width: calc(50% - 25px);
      }
    }
  }

  ${SLoading} {
    height: 150px;
  }
`;
